/** @jsxImportSource @emotion/react */

/**
 * Module dependencies.
 */

import { AnimationProps } from './in-view-once';
import { css } from '@emotion/react';

/** */

export function FadeInUp({ children, stateDelay }: AnimationProps) {
  return (
    <div
      css={css`
        opacity: ${stateDelay.hasEntered ? 1 : 0};
        transform: translateY(${stateDelay.hasEntered ? '0' : '20px'});
        transition:
          opacity 0.5s ease,
          transform 0.5s ease;
        will-change: opacity, transform;
        transition-delay: ${stateDelay.delay}ms;
      `}
    >
      {children}
    </div>
  );
}
